import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'digi-checkbox',
  templateUrl: './input-checkbox.component.html',
  styleUrl: './input-checkbox.component.scss'
})
export class InputCheckboxComponent {
  @Input() label: string = ''; // Nhãn cho checkbox
  @Input() control: FormControl = new FormControl(); // FormControl cho checkbox
  @Input() disabled: boolean = false; // Trạng thái disabled của checkbox
}
